module.exports = __webpack_public_path__ + "img/ostado-tutor-signup-why4.7b72177.gif";